import BAR__collection_current from '@/pages/page_generation/layouts/_base/bar_collection_current/BAR__collection_current';
import { FOOTER__column_right_default } from './FOOTER__column_right_default';
import { FOOTER__navigation } from './FOOTER__navigation';

interface PROPS {
  column_left?: React.ReactNode;
  column_center?: React.ReactNode;
  column_right?: React.ReactNode;
}

export function FOOTER__master({
  column_left = <FOOTER__navigation />,
  column_center = <BAR__collection_current />,
  column_right = <FOOTER__column_right_default />,
}: PROPS) {
  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <footer className="w-full h-16 min-h-16 bg-bar border-t border-component-border flex items-center justify-between relative z-50">
      {column_left}

      <div className="h-full flex-1 min-w-0">{column_center}</div>

      {column_right}
    </footer>
  );
}
